export default "__VITE_ASSET__DJnv7i3d__"